import StorefrontMock from "@/components/landing/ResponsiveShowcase/StorefrontMock";

interface MobileDeviceProps {
	shopLabel: string;
}

function MobileDevice(prop: MobileDeviceProps) {
	const { shopLabel } = prop;
	return (
		<div className="relative w-30 rounded-[2.25rem] border border-border bg-surface p-1.5 shadow-(--shadow)">
			{/* Volume rocker + power button, sitting on the bezel edge. */}
			<span className="absolute -left-px top-14 h-4 w-0.75 rounded-l-sm bg-border" />
			<span className="absolute -left-px top-20 h-7 w-0.75 rounded-l-sm bg-border" />
			<span className="absolute -right-px top-16 h-9 w-0.75 rounded-r-sm bg-border" />

			<div className="relative aspect-9/18 overflow-hidden rounded-[1.875rem] bg-[#fefdfb]">
				{/* Dynamic island */}
				<div className="absolute left-1/2 top-1 z-10 h-1 w-4 -translate-x-1/2 rounded-full bg-slate-900" />

				{/* Status bar */}
				<div className="flex items-center justify-between px-4 pb-1 pt-3 text-[8px] font-semibold text-text">
					<span>9:41</span>
					<div className="relative h-2 w-3.5 rounded-xs border border-current">
						<span className="absolute top-1/2 -right-0.75 h-1 w-0.5 -translate-y-1/2 rounded-r-sm bg-current" />
					</div>
				</div>

				<StorefrontMock cols={2} shopLabel={shopLabel} />

				{/* Home indicator */}
				<div className="absolute bottom-2 left-1/2 h-1 w-9 -translate-x-1/2 rounded-full bg-muted/40" />
			</div>
		</div>
	);
}

export default MobileDevice;
